import script from "./ImportFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImportFile.vue?vue&type=script&lang=ts&setup=true"

import "./ImportFile.vue?vue&type=style&index=0&id=37bbc969&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37bbc969"]])

export default __exports__